import { useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';
import { breakpoints } from 'shared/theme/theme';

const useResponsive = () => {
    const isMobileOnly = useMediaQuery({
        maxWidth: breakpoints.mobileOnly - 1,
    });
    const isMobile = useMediaQuery({ maxWidth: breakpoints.mobile - 1 });
    const isTablet = useMediaQuery({
        maxWidth: breakpoints.tablet - 1,
    });
    const isDesktop = useMediaQuery({ minWidth: breakpoints.tablet });
    const isWideScreen = useMediaQuery({ minWidth: breakpoints.wideScreen });

    const Mobile = useMemo(() => ({ children }) => {
        return isMobile ? children : null;
    }, [isMobile]);

    const Tablet = useMemo(() => ({ children }) => {
        return isTablet ? children : null;
    }, [isTablet]);

    const Desktop = useMemo(() => ({ children }) => {
        return isDesktop ? children : null;
    }, [isDesktop]);

    const WideScreen = useMemo(() => ({ children }) => {
        return isWideScreen ? children : null;
    }, [isWideScreen]);

    return useMemo(() => ({
        Mobile,
        Tablet,
        Desktop,
        WideScreen,
        isMobileOnly,
        isMobile,
        isTablet,
        isDesktop,
        isWideScreen
    }), [Mobile, Tablet, Desktop, WideScreen, isMobileOnly, isMobile, isTablet, isDesktop, isWideScreen]);
};

export default useResponsive;
